<template>
   <div ref="imgContainer" class="att-stage">
      <slot></slot>
   </div>
</template>

<script>

    export default {
        name: 'Stage',
        data() {
            return {}
        }
    }
</script>

<style lang="scss">
   @import '../scss/the-goods';

   .att-stage {
      position        : fixed;
      height          : 100vh;
      width           : calc(50% + 1px);
      top             : 0;
      left            : 0;
      overflow        : hidden;

      .intro-video-wrapper,
      .article-img {
        height : 100%;
        width  : 100%;
      }
   }

</style>



// WEBPACK FOOTER //
// src/components/Stage.vue